/**
 * Stores build information. The string literals are replaces at compile time by `set_version.js`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2024-01-15",
    versionChannel: "nightly",
    buildDate: "2024-01-15T00:15:42.928Z",
    commitHash: "a638715bd87d818d134a70659e7124234b992447",
};
